<script lang="ts">
	import { featureIcons, type FeatureIconKey, type FeaturesBaseProps } from "./features.types";
	import { SectionHeader } from "#lib/web-ui/primitives/index.js";
	import FeaturesBase from "./features-base.svelte";
	import { cn } from "#lib/web-ui/ui/utils.js";

	let {
		columns = 3,
		align = "center",
		...props
	}: FeaturesBaseProps & { columns?: 2 | 3; align?: "center" | "left" } = $props();

	function resolveIcon(icon: string) {
		return featureIcons[icon as FeatureIconKey];
	}
</script>

<FeaturesBase {...props}>
	{#snippet children({ label, title, subtitle, cards })}
		<SectionHeader {label} {title} {subtitle} {align} />

		<div class={cn("grid grid-cols-1 gap-8 sm:grid-cols-2", columns === 3 && "lg:grid-cols-3")}>
			{#each cards as card (card.title)}
				{@const IconComponent = resolveIcon(card.icon)}
				<div class="group relative h-full">
					<div
						class="from-primary/10 to-primary/5 absolute -inset-px rounded bg-gradient-to-tr opacity-50 blur-sm transition duration-300 group-hover:opacity-100"
					></div>
					<div
						class="bg-card text-card-foreground hover:bg-accent relative flex h-full flex-col rounded border p-8 transition-all duration-300"
					>
						<div
							class="bg-primary/10 mb-5 flex h-12 w-12 shrink-0 items-center justify-center rounded"
						>
							<IconComponent class="text-primary h-6 w-6" />
						</div>
						<h3 class="mb-3 text-xl font-semibold">{card.title}</h3>
						<p class="text-muted-foreground grow text-balance">
							{card.description}
						</p>
					</div>
				</div>
			{/each}
		</div>
	{/snippet}
</FeaturesBase>
